import React, { useState, useEffect } from 'react';
import api from '../../services/api';

/**
 * Gender on a member's Team365 record (Jenn, 2026-10-07): membership isn't
 * only for women now, and it may be used for targeted messaging later.
 * Team365 fills it in by hand for now. Saves as soon as a choice is picked.
 */
const OPTIONS = [
  ['', 'Not filled in'],
  ['female', 'Female'],
  ['male', 'Male'],
  ['non_binary', 'Non-binary'],
  ['prefer_not_to_say', 'Prefer not to say'],
];

export default function MemberGenderField({ memberId }) {
  const [gender, setGender] = useState(null);
  const [state, setState] = useState('');

  useEffect(() => {
    api.get(`/admin/members/${memberId}/gender`).then(r => setGender(r.data.gender || '')).catch(() => setGender(''));
  }, [memberId]);

  if (gender === null) return null;

  const change = async (value) => {
    const before = gender;
    setGender(value);
    setState('Saving…');
    try {
      await api.put(`/admin/members/${memberId}/gender`, { gender: value || null });
      setState('Saved');
      setTimeout(() => setState(''), 1500);
    } catch {
      setGender(before);
      setState('Could not save');
    }
  };

  return (
    <label className="text-xs text-gray-500 inline-flex items-center gap-1.5">
      Gender
      <select value={gender} onChange={e => change(e.target.value)}
        className="border border-gray-200 rounded-lg px-2 py-1 text-xs text-reset-brown bg-white">
        {OPTIONS.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
      </select>
      {state && <span className="text-gray-400">{state}</span>}
    </label>
  );
}
